export const HEADER_MENU_CONFIG = [
  {
    action: "logout",
    label: "log_out_shift",
    icon:'logout'
  },
];
